module.exports = __webpack_public_path__ + "static/media/fingerprintLogin.bee84a7f.svg";